import React, {Component} from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {Carousel} from 'react-responsive-carousel';
import {computeSliderArrows, computeSliderCount, computeTotalSlides} from "./utils";
import icoForm from './assets/images/icon-form.png';

class FormsCarousel extends Component {
    render() {
        let listPresent = this.props.formsList && this.props.formsList.length > 0;
        if (listPresent) {
            return <FormsList
                formsList={this.props.formsList}
                onClick={(i) => this.props.onClick(i)}
                color={this.props.color}
                PCBID={this.props.PCBID}
            />;
        } else {
            return <EmptyList/>;
        }
    }
}

class FormsList extends Component {
    constructor(props) {
        super(props);
        this.handleWindowResize = this.handleWindowResize.bind(this);
        this.setTotalSlides = this.setTotalSlides.bind(this);
        this.setShowArrows = this.setShowArrows.bind(this);
        this.setSliderCount = this.setSliderCount.bind(this);
        this.state = {
            totalSlidesCount: this.computeTotalSlidesCount(),
            totalSlides: computeTotalSlides(this.props.formsList.length / 3, 1),
            sliderCount: computeSliderCount(1),
            showArrows: computeSliderArrows(this.props.formsList.length / 3, 1),
        };
    }

    componentWillUnmount() {
        window.clearTimeout(this.throttle);
        window.removeEventListener('resize', this.handleWindowResize, false);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleWindowResize, false);
    }

    computeTotalSlidesCount() {
        return this.props.formsList.length;
    }

    setTotalSlides() {
        let formsCount = this.computeTotalSlidesCount()
        const totalSlides = computeTotalSlides(formsCount, 1);
        if (this.state.totalSlides !== totalSlides) {
            this.setState({
                totalSlides: totalSlides
            });
        }
    }

    setSliderCount() {
        const sliderCount = computeSliderCount(1);
        if (this.state.sliderCount !== sliderCount) {
            this.setState({
                sliderCount: sliderCount
            });
        }
    }

    handleWindowResize() {
        window.clearTimeout(this.throttle);
        this.throttle = window.setTimeout(this.setTotalSlides, 200);
        this.throttle = window.setTimeout(this.setSliderCount, 200);
        this.throttle = window.setTimeout(this.setShowArrows, 200)
    }

    handleClick = (event) => {
        let index = parseInt(event.target.parentElement.dataset.key)
        this.props.onClick(index)
    }

    setShowArrows() {
        const showArrows = computeSliderArrows(this.props.formsList.length, 3);
        if (this.state.showArrows !== showArrows) {
            this.setState({
                showArrows: showArrows
            });
        }
    }

    splitArrayIntoChunks(arr, len) {
        var chunks = [], i = 0, n = arr.length;
        while (i < n) {
            chunks.push(arr.slice(i, i += len));
        }
        return chunks;
    }

    render() {
        let Icon = '';
        return (
            <>
                <Carousel
                    showThumbs={false}
                    onSwipeEnd={false}
                    onClickItem={false}
                    onSwipeStart={false}
                    onSwipeMove={false}
                    swipeable={false}
                    infiniteLoop={false}
                    centerMode={true}
                    showArrows={this.state.showArrows}
                    slidesCount={this.state.sliderCount}
                    centerSlidePercentage={100 / this.state.totalSlides}
                >
                    {this.splitArrayIntoChunks(this.props.formsList, 3).map((formArray, index) => (
                        <div>
                            {formArray.map((form, index) => (
                                <ul className="content-list">
                                    <li className="content-list__item">
                                        <img src={icoForm} alt={document.title}/>
                                        <h3 className="content-list__item__name">{form.name}</h3>
                                        <DownloadRedirectButton form={form} PCBID={this.props.PCBID}/>
                                        {/*<RedirectButton form={form} PCBID = {this.props.PCBID}/>*/}
                                        {/*<DownloadButton form={form} PCBID = {this.props.PCBID}/>*/}
                                    </li>
                                </ul>
                            ))}
                        </div>
                    ))}
                </Carousel>
            </>
        );
    }
}

function EmptyList(props) {
    return <h1> No Forms </h1>;
}

class DownloadRedirectButton extends Component {
    render() {
        let pdfPresent = this.props.form.pdf;
        let urlPresent = this.props.form.url;
        if (pdfPresent) {
            return <DownloadButton form={this.props.form} PCBID={this.props.PCBID}/>
        } else if (urlPresent) {
            return <RedirectButton form={this.props.form}/>
        }
    }
}

class DownloadButton extends Component {

    downloadForm = (activeForm, e) => {
        e.preventDefault();
        fetch(process.env.REACT_APP_BASE_URL + "web/" + this.props.PCBID + "/downloadForm?id=" + activeForm.id, {
            headers: {
                Accept: 'application/docx',
            },
            responseType: 'arraybuffer'
        })
            .then(response => {
                console.log(response);
                if (response.ok) {
                    return response.blob();
                }
            })
            .then(blob => {
                const data = URL.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = data;
                let nameSplit = activeForm.pdf.split('.');
                let extension = nameSplit[nameSplit.length - 1];
                a.download = activeForm.name + '.' + extension;
                a.click();
                window.URL.revokeObjectURL(data);
            })
            .catch((err) => {
                alert("Something went wrong please try again later")
            });
    }

    render() {
        return (
            <a href='#' className="btn btn__borderd" target="_blank"
               onClick={i => this.downloadForm(this.props.form, i)}>
                DOWNLOAD
            </a>
        )
    }
}

class RedirectButton extends Component {
    render() {
        return <a className="btn btn__borderd" href={this.props.form.url} target="_blank">
            VIEW
            {/* <img className="content-list__item__image"
                 alt="View" title="View" /> */}
        </a>
    }
}

export default FormsCarousel;